module.exports = __webpack_public_path__ + "static/media/approval_1.f1a61268.png";